import React from 'react';
import classNames from 'classnames';
import { List, ListItem } from '../components/Generic/List';
import { Button } from '../components/Generic/Button';
import sitemapStyles from '../components/Brand/Sitemap/Sitemap-tw-styles';
import global from '../constants/global';
import urlProvider from './url-manager/urlProvider';
import Typography from '../components/Generic/Typography';
import DOMPurify from 'isomorphic-dompurify';

function getContentTypeID(typename) {
  const {
    contentPage,
    productPage,
    articleListPage,
    articlePage,
    productListPage,
  } = global.contentType;
  let contentTypeId;
  switch (typename) {
    case 'ProductList':
      contentTypeId = productListPage;
      break;
    case 'ContentPage':
      contentTypeId = contentPage;
      break;
    case 'ArticleList':
      contentTypeId = articleListPage;
      break;
    case 'Article':
      contentTypeId = articlePage;
      break;
    case 'CompareProducts':
      contentTypeId = productListPage;
      break;
    case 'Product':
      contentTypeId = productPage;
      break;
    default:
      break;
  }
  return contentTypeId;
}

function getContentTypeItem(page, locale) {
  const sitemapItem = {};
  if (page && page.__typename === 'LinkButton') {
    sitemapItem.sitemapLink = page.link;
    sitemapItem.sitemapText = page.linkText;
  } else if (page && page.__typename === 'MegaMenu') {
    sitemapItem.sitemapLink = page.menuLink;
    sitemapItem.sitemapText = page.sitemapText
      ? page.sitemapText
      : page.menuText;
  } else if (page && page.__typename === 'MenuSlot') {
    sitemapItem.sitemapLink = page.link;
    sitemapItem.style = page.styles;
    sitemapItem.sitemapText = page.sitemapText ? page.sitemapText : page.title;
  } else if (page && page.__typename === 'MenuItem') {
    sitemapItem.sitemapLink = page.menuLink;
    sitemapItem.style = page.styles;
    sitemapItem.sitemapText = page.sitemapText
      ? page.sitemapText
      : page.menuText;
  } else if (page) {
    if (page && page.__typename === 'Category') {
      sitemapItem.sitemapLink = page.slug ? page.slug : null;
    } else {
      const siteUrl = urlProvider(
        getContentTypeID(page.__typename),
        locale,
        page.slug
      );
      sitemapItem.sitemapLink =
        siteUrl && siteUrl.path
          ? siteUrl.path
          : page.slug
          ? `/${page.slug}`
          : null;
    }
    if (page.__typename === 'Product') {
      sitemapItem.sitemapText = page.productName
        ? page.productName
        : page.breadcrumbTitle
        ? page.breadcrumbTitle
        : page.title;
    } else if (page.__typename === 'ContentPage') {
      sitemapItem.sitemapText = page.sitemaptitle
        ? page.sitemaptitle
        : page.breadcrumbTitle
        ? page.breadcrumbTitle
        : page.title;
    } else {
      sitemapItem.sitemapText = page.sitemapTitle
        ? page.sitemapTitle
        : page.breadcrumbTitle
        ? page.breadcrumbTitle
        : page.title;
    }
  }
  return sitemapItem;
}

export const renderSitemapSection = (sectionItem, level = 0, pageContext) => {
  let sitemapLevelClassName = sitemapStyles.sitemapLevel[level];
  return (
    sectionItem.parentPageCollection &&
    sectionItem.parentPageCollection.items.map(parentContent => {
      if (parentContent) {
        let sitemapItem = getContentTypeItem(parentContent, pageContext.locale);
        return (
          <ListItem
            key={parentContent.sys && parentContent.sys.id}
            className={sitemapLevelClassName && sitemapLevelClassName.li}
          >
            {sitemapItem.sitemapLink ? (
              <Button
                to={sitemapItem.sitemapLink}
                locale={pageContext.locale}
                className={sitemapLevelClassName && sitemapLevelClassName.link}
              >
                <Typography
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html:DOMPurify.sanitize( sitemapItem.sitemapText),
                  }}
                />
              </Button>
            ) : (
              <Typography
                component="div"
                className={
                  sitemapLevelClassName && sitemapLevelClassName.button
                }
                dangerouslySetInnerHTML={{
                  __html:DOMPurify.sanitize( sitemapItem.sitemapText),
                }}
              />
            )}
            <List className={sitemapLevelClassName && sitemapLevelClassName.ul}>
              {sectionItem.childPageCollection &&
                sectionItem.childPageCollection.items.map(childContent => {
                  if (childContent) {
                    const typename = childContent.__typename;
                    sitemapLevelClassName =
                      sitemapStyles.sitemapLevel[level + 1];
                    if (typename === 'SitemapSection')
                      return renderSitemapSection(
                        childContent,
                        level + 1,
                        pageContext
                      );

                    sitemapItem = getContentTypeItem(
                      childContent,
                      pageContext.locale
                    );
                    return (
                      <ListItem
                        key={childContent.sys && childContent.sys.id}
                        className={
                          sitemapLevelClassName && sitemapLevelClassName.li
                        }
                      >
                        <span className={sitemapStyles.siteMapLinkBtn} />
                        {sitemapItem.sitemapLink ? (
                          <Button
                            to={sitemapItem.sitemapLink}
                            locale={pageContext.locale}
                            className={
                              sitemapLevelClassName &&
                              sitemapLevelClassName.link
                            }
                          >
                            <Typography
                              component="span"
                              className={classNames(sitemapItem.style)}
                              dangerouslySetInnerHTML={{
                                __html:DOMPurify.sanitize( sitemapItem.sitemapText),
                              }}
                            />
                          </Button>
                        ) : (
                          <Typography
                            component="div"
                            className={
                              sitemapLevelClassName &&
                              sitemapLevelClassName.button
                            }
                            dangerouslySetInnerHTML={{
                              __html:DOMPurify.sanitize( sitemapItem.sitemapText),
                            }}
                          />
                        )}
                      </ListItem>
                    );
                  }
                })}
            </List>
          </ListItem>
        );
      }
    })
  );
};

export default renderSitemapSection;
